<div [ngClass]="isFixed ? '' : 'flex-1 w-full h-full min-h-60'" class="flex flex-col items-center justify-center p-4">
    <img [src]="imagen_src" class="mt-4 rounded-2xl" [ngClass]="isFixed ? 'w-20 lg:w-24' : 'w-16 h-16'" />
    <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
    <span *ngIf="message" class="mt-4 text-lg font-semibold text-gray-600 text-center">{{ message }}</span>
</div>